import * as React from 'react';
import {
  createStyles, withStyles
} from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { RouteComponentProps } from 'react-router-dom';
import ExtractionDialog from './extractionDialog';

interface Props extends
  RouteComponentProps<{
    doc: string;
  }> { }

class TranscriptorExtractionDialog extends React.Component<Props, {}> {
  render = () => {
    return (
      <ExtractionDialog
        {...this.props}
        handleNavigate={(id: string | null) => {
          if (id) {
            this.props.history.push(`/extractions/${id}`);
          } else {
            this.props.history.goBack();
          }
        }}
      />
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({});

export default withStyles(styles)(TranscriptorExtractionDialog);
